<template>
    <div class="gallery">
        <br>
        <img id="logo"
            src="https://firebasestorage.googleapis.com/v0/b/swanmoments-f3801.appspot.com/o/Boda%20Delgado%20Calles%2FNuestros-momentos.svg?alt=media&token=b2eb32d7-8b21-4739-8110-cb0a5835a14f"
            alt="" width="14rem">
            <h3>Nuestros Momentos</h3>
        

            <Slider animation="fade" v-model="sliderValue" :duration="5000" :speed="1000" :indicators="false" :control-btn="false" id="photo">
                <SliderItem v-for="(i, index) in  Gallery " :key="index" @click="changeIndex(1);">
                    <img :src="i.Foto" class="photo">
                </SliderItem>
            </Slider>
    </div>
</template>

<script>
import axios from 'axios';
import { Slider, SliderItem } from "vue-easy-slider";

export default {
    name: 'Gallery',
    props: {
        Code: {
            type: String,
            required: true
        },
    },
    components: {
        Slider,
        SliderItem
    },
    data() {
        return {
            Gallery: [],
            sliderValue:2
        };
    },
    methods: {
        getMyGallery() {
            let url = process.env.VUE_APP_API_DEV ? `${process.env.VUE_APP_API_DEV}Gallery/GetMyGallery/${this.Code}` : `${process.env.VUE_APP_API_PRO}Gallery/GetMyGallery/${this.Code}`;
            axios.get(url)
                .then((response) => this.Gallery = response.data)
                .catch(err => console.error(err));
        },

        changeIndex(index) {
            this.sliderValue = index;
        }
    },
    created() {
        this.getMyGallery();
    },
}
</script>

<style scoped>
.gallery {
    display: grid;
    grid-template-columns: 1fr;
    grid-column-gap: 0px;
    grid-row-gap: 10px;
    width: 100%;
    place-items: center;
}

h3 {
    font-family: var(--titulos);
    color: var(--title);
    font-size: 2rem;
}

.gallery>#logo {
    width: 5rem;
}

.slider{
    width: 852px !important;
    height: 1280px !important;
}

.slider-item > img{
    width: 100% !important;
}

@media (max-width: 768px) {
    .slider{
    width: 300px !important;
    height: 451px !important;
}
}
</style>
